import React from 'react'
import PropTypes from 'prop-types'

const ListPenIcon = (props) => {
  const { color = '#183560', classes = 'w-20' } = props
  return (
    <svg
      viewBox="0 0 18 19"
      fill="none"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4503 7.625C10.4503 8.0375 10.1128 8.375 9.70032 8.375H2.95032C2.53782 8.375 2.20032 8.0375 2.20032 7.625C2.20032 7.2125 2.53782 6.875 2.95032 6.875H9.70032C10.1128 6.875 10.4503 7.2125 10.4503 7.625ZM2.20032 4.625C2.20032 5.0375 2.53782 5.375 2.95032 5.375H9.70032C10.1128 5.375 10.4503 5.0375 10.4503 4.625C10.4503 4.2125 10.1128 3.875 9.70032 3.875H2.95032C2.53782 3.875 2.20032 4.2125 2.20032 4.625ZM7.45032 10.625C7.45032 10.2125 7.11282 9.875 6.70032 9.875H2.95032C2.53782 9.875 2.20032 10.2125 2.20032 10.625C2.20032 11.0375 2.53782 11.375 2.95032 11.375H6.70032C7.11282 11.375 7.45032 11.0375 7.45032 10.625ZM13.4578 9.0275L13.9903 8.495C14.2828 8.2025 14.7553 8.2025 15.0478 8.495L15.5803 9.0275C15.8728 9.32 15.8728 9.7925 15.5803 10.085L15.0478 10.6175L13.4578 9.0275ZM12.9253 9.56L9.05532 13.43C8.98782 13.4975 8.95032 13.5875 8.95032 13.6925V14.75C8.95032 14.96 9.11532 15.125 9.32532 15.125H10.3828C10.4803 15.125 10.5778 15.0875 10.6453 15.0125L14.5153 11.1425L12.9253 9.56Z"
        fill={color}
      />
    </svg>
  )
}

ListPenIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(ListPenIcon)
